module.exports = __webpack_public_path__ + "static/media/21.8876b1e.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/21.wav
// module id = n2Zn
// module chunks = 0